import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/shared/lib/utils';

export interface InlineMetricProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  label: ReactNode;
  value: ReactNode;
}

export function InlineMetric({ label, value, className, ...rest }: InlineMetricProps) {
  return (
    <div
      className={cn('phx-inline-metric inline-flex min-w-0 flex-col gap-[2px]', className)}
      {...rest}
    >
      <span className="text-phx-xs text-phx-text-muted font-semibold tracking-wider uppercase">
        {label}
      </span>
      <span className="text-phx-lg text-phx-text font-semibold tabular-nums">{value}</span>
    </div>
  );
}
